import { lazy } from 'react';

export const ForbiddenPageLazy = lazy(() => import('./forbidden-page'));
